import script from "./CreateOrUpdateForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateOrUpdateForm.vue?vue&type=script&setup=true&lang=js"

import "./CreateOrUpdateForm.vue?vue&type=style&index=0&id=5b80fe6c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b80fe6c"]])

export default __exports__